import { handlePromoProducts } from '../acf-blocks/promo-products';
import { handleFormQty } from '../components/form-qty';
import { getCookie, setCookie } from './cookies';

export class Favourties {
    constructor() {
        this.set();
        this.init();
    }

    set() {
        this.cookieFavName = 'mda_favourties';
        this.addToFavClass = 'js-add-to-fav';
        this.removeFromFavClass = 'js-remove-from-fav';
        this.listingFavourites = document.querySelector(
            '.js-favourties-listing-wrapper'
        );
    }
    init() {
        window.addEventListener('click', e => {
            const { target } = e;
            const cookieDataAttribute = target.getAttribute(
                'data-fav-product-id'
            );

            if (cookieDataAttribute) {
                this.handleFavElementClick(target, cookieDataAttribute);
            }

            if (target.classList.contains('js-clear-favourites')) {
                setCookie(this.cookieFavName, JSON.stringify([]), 365);
                this.updateHeaderCount();
                this.refetchFavouritesListing();
            }
        });
    }

    handleFavElementClick(target, productId) {
        const isAddedToFavList = target.classList.contains(
            this.removeFromFavClass
        );

        this.beforeClick(target);
        this.handleCookie(isAddedToFavList ? 'remove' : 'add', productId);
        this.updateHeaderCount();
        target.classList.remove(
            isAddedToFavList ? this.removeFromFavClass : this.addToFavClass
        );

        setTimeout(() => {
            target.classList.add(
                isAddedToFavList ? this.addToFavClass : this.removeFromFavClass
            );
            this.afterClick(target);
        }, 100);

        if (this.listingFavourites) {
            this.refetchFavouritesListing();
        }
    }

    handleCookie(type = 'add', productId) {
        const cookie = getCookie(this.cookieFavName);
        if (type === 'add') {
            if (!cookie) {
                const value = JSON.stringify([productId]);
                setCookie(this.cookieFavName, value, 365);
            } else {
                const currentCookieVal = JSON.parse(cookie);
                currentCookieVal.push(productId);
                setCookie(
                    this.cookieFavName,
                    JSON.stringify(currentCookieVal),
                    365
                );
            }
        } else {
            const currentCookieVal = JSON.parse(cookie);
            const cookieValToSet = currentCookieVal.filter(
                item => item !== productId
            );
            setCookie(this.cookieFavName, JSON.stringify(cookieValToSet), 365);
        }
    }

    async refetchFavouritesListing() {
        const loader = this.listingFavourites.querySelector('.loader');

        try {
            loader.classList.add('-active');

            const formData = new FormData();
            formData.append('action', 'refetch_favourites_listing');
            formData.append('nonce', ajax.nonce);

            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });

            const { data } = await req.json();
            const { html } = data;

            if (html) {
                this.listingFavourites.innerHTML = html;
                handleFormQty();
                handlePromoProducts();
            }
        } catch (error) {
        } finally {
            loader.classList.remove('-active');
        }
    }

    beforeClick(target) {
        target.classList.add('-active');
    }

    afterClick(target) {
        setTimeout(() => {
            target.classList.remove('-active');
        }, 400);
    }

    updateHeaderCount() {
        const counterEl = document.querySelector(
            '.header-middle__cart-count.-favourites'
        );
        if (!counterEl) return;

        const cookie = getCookie(this.cookieFavName);
        const count = cookie ? JSON.parse(cookie).length : 0;
        counterEl.textContent = count;
    }
}
